import {
  GET_PETITIONS_REQUEST,
  GET_PETITIONS_SUCCESS,
  GET_PETITIONS_FAILED,
} from './actionTypes';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 50,
  selectedUserId: null,
};

const petitionsReducer = (state = initialState, {
  type, error, data, meta,
}) => {
  switch (type) {
    case GET_PETITIONS_REQUEST:
      return { ...state, loading: true };
    case GET_PETITIONS_SUCCESS:
      return {
        ...state,
        data: data.map((i) => ({ ...i, _selected: false })),
        search: meta.search,
        page: meta.page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        sort: meta.sort,
        order: meta.order,
        loading: false,
      };
    case GET_PETITIONS_FAILED:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default petitionsReducer;
